import type { NamespaceCatalog } from './index';
import catalog from './workspace-feedback.json';

export type WorkspaceFeedbackCopyKey = keyof typeof catalog.en;

const workspaceFeedbackCopy = catalog as NamespaceCatalog<WorkspaceFeedbackCopyKey>;

export default workspaceFeedbackCopy;
